import { useAuth } from "hooks/Auth";
import React, { useEffect, useCallback, useState, useContext } from "react";
import Container from "Screens/Container";
import { oauthGet } from "helpers/Request";
import { transform as roleTransformer } from "schemas/Role";
import { getPaginationMeta } from "schemas/Util";
import GroupTable from "./GroupTable";
import { AppContext } from "context/App";
import Pagination from "components/Pagination";
import { useLocation, useHistory } from "react-router-dom";
import LowTextInput from "components/FormElements/LowTextInput";
import AdminScreen from "Screens/AdminScreen";

export default function GroupScreen(props) {
    const auth = useAuth();
    const location = useLocation();
    const history = useHistory();
    const [groups, setGroups] = useState([]);
    const [pagination, setPagination] = useState(null);

    const { setCurrentNav } = useContext(AppContext);

    const updateParams = (vals) => {
        const params = new URLSearchParams(location.search);

        Object.entries(vals).forEach(([k, v]) => {
            if (v === null) {
                params.delete(k);
                return;
            }
            params.set(k, v);
        });

        history.replace(location.pathname + "?" + params.toString());
    };

    const loadGroups = useCallback(() => {
        const defaultParams = { page: 1 };
        const definedParams = Object.fromEntries(
            new URLSearchParams(location.search)
        );

        oauthGet(
            "/api/v2/role",
            Object.assign(defaultParams, definedParams, {
                license: auth.publication.uuid,
            })
        ).then((data) => {
            setGroups(roleTransformer(data));
            setPagination(getPaginationMeta(data));
        });
    }, [auth.publication, location]);

    useEffect(() => {
        loadGroups();
    }, [loadGroups, location]);

    useEffect(() => {
        setCurrentNav("group");
    }, [setCurrentNav]);

    return (
        <AdminScreen>
            <Container>
                <div className="space-y-4">
                    <div className="flex space-x-4 items-center">
                        <div className="grow">
                            <LowTextInput
                                placeholder="Search Groups"
                                onEnter={(val) => {
                                    updateParams({ keyword: val || null });
                                }}
                            />
                        </div>
                    </div>
                    <GroupTable groups={groups} />
                    <Pagination {...pagination} basePath="/app/group" />
                </div>
            </Container>
        </AdminScreen>
    );
}
